import axios from "axios";

import { routes } from "../../constants";
import { tableTokenConfig } from "./tableTokenConfig";

/** Withdraw the guest edit or removal waiting for approval on one seat. */
const cancelSeatChange = async (code, position, token = null) => {
  const response = await axios.delete(
    routes.tableSeatChangeRequest(code, position),
    tableTokenConfig(token)
  );
  return response;
};
export default cancelSeatChange;
